// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import CustomerProxy from "@/proxies/CustomerProxy"

const state = {
  customers: [],
  customer: {}
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, params = {}) {
    let response = await new CustomerProxy(params).all()
    commit("SET_CUSTOMERS", response)
  },

  async find({ commit }, id, params = {}) {
    let response = await new CustomerProxy(params).find(id)
    commit("SET_CUSTOMER", response)
  },

  async create(_, item) {
    return await new CustomerProxy().create(item)
  },

  async update({ dispatch }, { id, data, params = {} }) {
    let response = await new CustomerProxy(params).update(id, data)
    await dispatch("find", id)
    return response
  },

  async destroy(_, id, params = {}) {
    return await new CustomerProxy(params).destroy(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
